import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { HeroSection } from "./components/sections/HeroSection";
import { ClinicalDecisionSection } from "./components/sections/ClinicalDecisionSection";
import { FrameworkSection } from "./components/sections/FrameworkSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { PainPointsSection } from "./components/sections/PainPointsSection";
import { GapSection } from "./components/sections/GapSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { ResourcesSection } from "./components/sections/ResourcesSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { AuthorSection } from "./components/sections/AuthorSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection } from "./components/sections/FinalCtaSection";
import { SiteFooter } from "./components/sections/SiteFooter";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="7sulgbavp5r">
      <MetaPixel data-id="element-1" data-mp="2zm4vedw4z0yn" />
      <HeroSection data-id="element-2" data-mp="2zmo89g6xiz5t" />
      <main data-id="element-3" data-mp="2zng14j956ise">
        <ClinicalDecisionSection data-id="element-4" data-mp="33mowttnqsqql" />
        <FrameworkSection data-id="element-5" data-mp="33nq73vwxp979" />
        <BeforeAfterSection data-id="element-6" data-mp="33mymfg4vkvvr" />
        <PainPointsSection data-id="element-7" data-mp="38lrnua6w0wfk" />
        <GapSection data-id="element-8" data-mp="38li8rhnds9on" />
        <VolumesSection data-id="element-9" data-mp="38l05i12awv78" />
        <ResourcesSection data-id="element-10" data-mp="38nunzn1r85y0" />
        <BonusesSection data-id="element-11" data-mp="3dkl42adk71jf" />
        <OfferSection data-id="element-12" data-mp="3dl4jnkfqldua" />
        <GuaranteeSection data-id="element-13" data-mp="3dmfqjt4hb1pm" />
        <TestimonialsSection data-id="element-14" data-mp="3dii4aymltu1i" />
        <AuthorSection data-id="element-15" data-mp="nw2ci75e7srm" />
        <FaqSection data-id="element-16" data-mp="nur7k407oeyx" />
        <FinalCtaSection data-id="element-17" data-mp="nvar1p5ifbf2" />
      </main>
      <SiteFooter data-id="element-18" data-mp="sudkecc4nt77" />
      <FloatingCta data-id="element-19" data-mp="stuclog6yl6w" />
      <PurchasePopup data-id="element-20" data-mp="stc6m03q8sls" />
    </div>;
}